import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Box, Typography, Grid } from '@mui/material';
import { addType } from '../../api/axios';
import Types from '../List/Types';

const NewType = () => {
    const { t } = useTranslation("global");
    const [typeName, setTypeName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleSubmit = async () => {
        if (!typeName.trim()) {
            setErrorMessage(t('priceList.PleaseEnterATypeName'));
            return;
        }

        try {
            const param = new URLSearchParams();
            param.append("type_name", typeName);
            await addType(param);
            setSuccessMessage(t('priceList.TypeAddedSuccessfully'));
            setErrorMessage('');
            setTypeName(''); // Reset the input field
            // Trigger refresh of Types table by re-rendering the component
            window.dispatchEvent(new Event('refreshTypes'));
        } catch (error) {
            setErrorMessage(t('priceList.FailedToAddType'));
            setSuccessMessage('');
        }
    };

    const handleChange = (event) => {
        const input = event.target.value.toUpperCase(); // Convert input to uppercase
        setTypeName(input);
    };

    return (
        <Grid container spacing={2} sx={{
                width: '100%',
                maxWidth: '80%',
                margin: '0 auto',
                mt: 4,
                backgroundColor: 'white',
                p: 5,
                borderRadius: 3,
            }}>
            <Grid item xs={12}>
                <Typography variant="h5" textAlign="center">
                    {t('priceList.AddNewType')}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    label={t('priceList.TypeName')}
                    value={typeName}
                    onChange={handleChange}
                    fullWidth
                    error={!!errorMessage}
                    helperText={errorMessage || ''}
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                />
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    fullWidth
                >
                    {t("priceList.Submit")}
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Types />
            </Grid>
            <Grid item xs={12}>
                {successMessage && (
                    <Typography variant="body1" color="success.main" textAlign="center">
                        {successMessage}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};

export default NewType;

